export const WarningProductModal = {
    title: "Huỷ bỏ",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn " +
        "muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.",
};

export const WarningUnsavedChanges = {
    title: "Cảnh báo",
    context: 
        "Có trường dữ liệu bị thay đổi nhưng chưa được lưu. " +
        "Bạn có muốn lưu thông tin trước khi rời đi?",
    closeButtonText: "Không lưu",
    confirmButtonText: "Lưu",
    cancelButtonText: "Chỉnh sửa",
};

export const WarningCancelProductOrder = {
    title: "Huỷ đơn hàng",
    context: 
        "Huỷ đơn hàng sẽ tạm dừng tất cả các hoạt động liên quan, bạn có chắc muốn huỷ bỏ không? " +
        "Hành động này sẽ không được hoàn tác.",
};

export const WarningDiscardCreateProductOrder = {
    title: "Huỷ tạo đơn hàng",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn " +
        "muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.",
};

export const WarningDeliverFailProductOrder = {
    title: "Giao hàng không thành công",
    context: [
        "Vui lòng nhập mô tả chi tiết bên dưới lý do giao hàng không thành công.",
        "Trong những trường hợp sau, vui lòng chọn nút tương ứng:",
        '1. Trong trường hợp do lỗi vận chuyển, bấm "Gửi ghi chú".',
        '2. Trong trường hợp khách hàng từ chối, bấm "Hủy đơn hàng".',
    ],
    reason: "Lý do giao hàng không thành công",
};

export const WarningDeclineProductOrder = {
    title: "Từ chối duyệt đơn hàng",
    context: [
        "Bạn có chắc chắn muốn từ chối duyệt đơn hàng này không? Hành động này sẽ không được hoàn tác",
    ],
    reason: "Lý do từ chối",
};

export const WarningDeclineReasonProductOrder = {
    title: "Lý do đơn hàng vật tư bị từ chối",
};
